const fallbackSrc = {
  bind: (el, binding) => {
    const handler = e => {
      el.src = binding.value;
      el.removeEventListener('error', handler);
    };
    el.addEventListener('error', handler);
  },

  inserted: (el, binding, vnode) => {
    el.style.backgroundImage = `url('${binding.value}')`;
  }
};

export default fallbackSrc;



// WEBPACK FOOTER //
// ./src/directives/fallback-src.directive.js